import { requestSuccess } from "@Api";
import { SET_PANEL } from "@Actions/types";

const setPanel = (type) => {
	return (dispatch) => {
		dispatch(requestSuccess(SET_PANEL, type));
	};
};

export default setPanel;
